<template>
    <v-menu dark open-on-hover bottom offset-y max-height="400px">
        <template v-slot:activator="{ on }">
            <v-btn icon flat v-on="on" :style="$store.state.textFormatting.main"> <v-icon > {{icon}} </v-icon></v-btn>
            <transition name="scale-transition" />
        </template>
        <v-list>
            <v-list-tile class="tile" active-class="cyan--text" v-for="item in routes" :key="item.name" :to="item.route">
                <v-list-tile-title :style="$store.state.textFormatting.main"> {{item.name}} </v-list-tile-title>
            </v-list-tile>
        </v-list>
    </v-menu>
</template>

<script>
import {Auth} from 'aws-amplify'

export default {
    name: 'adminnav',
    props: ['pagetype', 'userType'],
    data () {
        return {
        routes: [],
        icon: "",
        listtitle: ""
        }
    },
    mounted () {
        this.setUserNav()
    },
    methods: {
        setUserNav: async function () {
            var user_type = await this.getUserType()
            if (user_type.attributes.name == "Admin") {
                if (this.pagetype == "user") {
                    this.routes = [
                        {id: 5, name: 'Organisation Admin', route: '/orgAdmin'},
                        {id: 4, name: 'User Admin', route: '/userAdmin'},
                    ]
                    this.icon = "account_circle"
                    this.listtitle = "User"
                } else if (this.pagetype == "system") {
                    this.routes = [
                        {id: 2, name: 'Edit ASNs', icon: 'add', route: '/asnSettings'},
                        {id: 11, name: 'Edit Restricted Prefixes', icon: 'add', route: '/prefixSettings'},
                        {id: 24, name: 'Alert Refinement', icon: 'add', route: '/alertRefinement'},
                        {id: 24, name: 'Alert Rules (new)', icon: 'add', route: '/alertRules'}
                    ]
                    this.icon = "settings_input_component"
                    this.listtitle = "ASN/Prefix"
                } else if (this.pagetype == "chart") {
                    this.routes = [
                        {id: 10, name: 'Search Events/Episodes/Notifications', icon: 'timer', route: '/searchEvents'},
                        {id: 12, name: 'System Statistics', icon: 'equalizer', route: '/statistics'},
                        //{id: 9, name: 'Disaggregation', icon: 'search', route: '/disaggregation'},
                        {id: 16, name: 'Prefix Routing', route: '/prefixRouting'},
                        {id: 17, name: 'ASN Baseline', route: '/ASNBaseline'},
                        {id: 18, name: 'Country ASNs', route: '/countryASN'},
                        //{id: 19, name: 'ASN Owners', route: '/asnOwners'},
                        {id: 20, name: 'Request Data', route: '/rawData'},
                        {id: 21, name: 'Top ASNs', route: '/topASNs'},
                    ]
                    this.icon = "equalizer"
                    this.listtitle = "Components"
                } else if (this.pagetype == "home") {
                    this.routes = [
                        {id: 13, name: 'Homepage', icon: 'home', route: '/'}
                        ]
                    this.icon = "home"
                    this.listtitle = "Home"
                }  else if (this.pagetype == "alert") {
                    this.routes = [
                        {id: 22, name: 'Organisation Alerts', icon: 'notification_important', route: '/orgAlerts'},
                        {id: 23, name: 'User Alerts', icon: 'notification_important', route: '/userAlerts'},
                    ]
                    this.icon = "notification_important"
                    this.listtitle = "Alerts"
                } 
            } else if (user_type.attributes.name =="Developer") {
                if (this.pagetype == "user") {
                    this.routes = [
                        {id: 4, name: 'User Admin', icon: 'settings', route: '/userAdmin'},
                    ]
                    this.icon = "account_circle"
                    this.listtitle = "User"
                } else if (this.pagetype == "system") {
                    this.routes = [
                        {id: 2, name: 'Edit ASNs', icon: 'add', route: '/asnSettings'},        
                        {id: 11, name: 'Edit Restricted Prefixes', icon: 'add', route: '/prefixSettings'},
                        {id: 24, name: 'Alert Refinement', icon: 'add', route: '/alertRefinement'},
                        {id: 24, name: 'Alert Rules (new)', icon: 'add', route: '/alertRules'}
                    ]
                    this.icon = "settings_input_component"
                    this.listtitle = "ASN/Prefix"
                } else if (this.pagetype == "chart") {
                    this.routes = [
                        {id: 10, name: 'Search Events/Episodes/Notifications', icon: 'timer', route: '/searchEvents'},
                        {id: 12, name: 'System Statistics', icon: 'equalizer', route: '/statistics'},
                        {id: 9, name: 'Disaggregation', icon: 'search', route: '/disaggregation'},
                        {id: 16, name: 'Prefix Routing', route: '/prefixRouting'},
                        {id: 17, name: 'ASN Baseline', route: '/ASNBaseline'},
                        {id: 18, name: 'Country ASNs', route: '/countryASN'},
                        //{id: 19, name: 'ASN Owners', route: '/asnOwners'}
                        {id: 21, name: 'Top ASNs', route: '/topASNs'},
                    ]
                    this.icon = "equalizer"
                    this.listtitle = "Components"
                } else if (this.pagetype == "home") {
                    this.routes = [
                        {id: 13, name: 'Home', icon: 'home', route: '/'}
                        ]
                    this.icon = "home"
                    this.listtitle = "Home"
                }  else if (this.pagetype == "alert") {
                    this.routes = [
                        {id: 22, name: 'Organisation Alerts', icon: 'notification_important', route: '/orgAlerts'},
                        {id: 23, name: 'User Alerts', icon: 'notification_important', route: '/userAlerts'}
                    ]
                    this.icon = "notification_important"
                    this.listtitle = "Alerts"
                } 
                
            } else if (user_type.attributes.name == "Analyst") {
                if (this.pagetype == "user") {
                    this.routes = [
                        {id: 4, name: 'User Admin', icon: 'settings', route: '/userAdmin'},
                    ]
                    this.icon = "account_circle"
                    this.listtitle = "User"
                } else if (this.pagetype == "chart") {
                    this.routes = [
                        {id: 10, name: 'Search Events/Episodes/Notifications', icon: 'timer', route: '/searchEvents'},
                        {id: 12, name: 'System Statistics', icon: 'equalizer', route: '/statistics'},
                        {id: 9, name: 'Disaggregation', icon: 'search', route: '/disaggregation'},
                        {id: 16, name: 'Prefix Routing', route: '/prefixRouting'},
                        {id: 17, name: 'ASN Baseline', route: '/ASNBaseline'},
                        {id: 18, name: 'Country ASNs', route: '/countryASN'},
                        //{id: 19, name: 'ASN Owners', route: '/asnOwners'}
                        {id: 21, name: 'Top ASNs', route: '/topASNs'},
                    ]
                    this.icon = "equalizer"
                    this.listtitle = "Components"
                } else if (this.pagetype == "home") {
                    this.routes = [
                        {id: 13, name: 'Home', icon: 'home', route: '/'}
                        ]
                    this.icon = "home"
                    this.listtitle = "Home"
                }  else if (this.pagetype == "alert") {
                    this.routes = [
                        {id: 22, name: 'Organisation Alerts', icon: 'notification_important', route: '/orgAlerts'},
                        {id: 23, name: 'User Alerts', icon: 'notification_important', route: '/userAlerts'}
                    ]
                    this.icon = "notification_important"
                    this.listtitle = "Alerts"
                } else if (this.pagetype == "system") {
                    this.routes = [
                        {id: 2, name: 'View ASNs', icon: 'add', route: '/asnSettings'},        
                        {id: 11, name: 'View Restricted Prefixes', icon: 'add', route: '/prefixSettings'},
                        {id: 24, name: 'Alert Refinement', icon: 'add', route: '/alertRefinement'},
                        {id: 24, name: 'Alert Rules (new)', icon: 'add', route: '/alertRules'}
                    ]
                    this.icon = "settings_input_component"
                    this.listtitle = "ASN/Prefix"
                }
            }
        },
        getUserType: async function () {
            const signedin = await Auth.currentAuthenticatedUser();
        //    console.log(signedin);
            return signedin;
        }
        
    }
}
</script>

<style scoped>
  .tile {
    margin: 5px;
    border-radius: 4px;
  }
  
  .tile:hover {
    background: cyan;
    color: black;
  }
  

</style>